// extracted by mini-css-extract-plugin
export default {"alertBody":"alertBody-DG3YG","body":"body-Ysu4P","header":"header-cVsrQ","warningIcon":"warningIcon-BNYE2"};